import { render, staticRenderFns } from "./DragableMultiselect.vue?vue&type=template&id=354816fc&"
import script from "./DragableMultiselect.vue?vue&type=script&lang=js&"
export * from "./DragableMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports